/**
 * Modul Checkout Steps
 */

import {
	needJquery,
	getTransitionDuration, extend
} from '../../../shared/utils/index';


import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from "../../../shared/dom/manipulator";

// Cart Components
import Participants from "./participants";
import Prices from "./prices";
import Events from "./events";
import Summary from "./summary";

// ------
// Public
// ------

const validateCheckoutButton = (element = null, state = false) => {
	if(!element) {
		return;
	}

	if(state) {
		Manipulator.removeClass(element, 'disabled');
		element.removeAttribute('disabled');

	} else {
		Manipulator.addClass(element, 'disabled');
		element.setAttribute('disabled', true);
	}
};

const init = () => {
	Participants.init();
	Prices.init();
	Events.init();
	Summary.init();
};

// ------
// Export
// ------

export default {
	init: init
};

export {validateCheckoutButton};